import {Profile, User} from "@graphql/generated";
import React from "react";

export const formattedDate = (date?: string) => {
    if (!date) {
        return 'N/A'
    }

    const dateObj = new Date(date)
    const dd = dateObj.getDate() < 10 ? '0' + String(dateObj.getDate()) : String(dateObj.getDate())
    const mm = (dateObj.getMonth() + 1) < 10 ? '0' + String(dateObj.getMonth() + 1) : String(dateObj.getMonth() + 1)
    const yyyy = dateObj.getFullYear()

    return dateObj ? `${dd}/${mm}/${yyyy}` : 'N/A'
}

export const TaskMessageHeader = (profile: Profile) => {
    const salutation = profile?.salutation ? profile.salutation === 'mr' ? 'heer' : 'mevrouw' : 'heer/mevrouw'
    return <p>Geachte {salutation} {profile?.surname},</p>
}
